<template>
  <div class="container">
    <div class="left-part">
      <div class="equipment-title" v-if="$route.query.id == undefined">
        电价录入
      </div>
      <div class="equipment-title" v-if="$route.query.id != undefined">
        电价修改
      </div>
    </div>
    <div style="width: 80vw; height: 100%">
      <el-form :model="form" ref="form" :rules="rules">
        <div class="form-item">
          <el-form-item label="企业名称：" prop="etId">
            <el-select
              placeholder="请选择企业名称"
              v-model="form.etId"
              style="width: 20vw"
              @change="changeCompany"
            >
              <el-option
                v-for="(item, index) in companyList"
                :key="index"
                :label="item.etName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="tip">（必填）</div>
          <el-form-item label="电价设置：">
            <div class="price-container">
              <div class="price-container">
                <div class="price-left">尖</div>
                <el-input
                  placeholder="请输入尖电价"
                  v-model="form.epTipPrice"
                  style="position: absolute; left: 2vw; width: 18vw"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="电站名称：" prop="psId">
            <el-select
              placeholder="请选择电站名称"
              v-model="form.psId"
              style="width: 20vw"
              :disabled="disabled"
            >
              <el-option
                v-for="(item, index) in stationList"
                :key="index"
                :label="item.psName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="tip">（必填）</div>
          <el-form-item>
            <div class="price-container" style="margin-left: 7.5vw">
              <div class="price-container">
                <div class="price-left">峰</div>
                <el-input
                  placeholder="请输入峰电价"
                  v-model="form.epPeakPrice"
                  style="position: absolute; left: 2vw; width: 18vw"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="电价折扣：">
            <el-input
              v-model="form.epDiscount"
              type="number"
              style="width: 20vw"
              placeholder="请输入电价折扣"
            ></el-input>
          </el-form-item>
          <div class="tip" style="width: 3.9vw">%</div>
          <el-form-item>
            <div class="price-container" style="margin-left: 7.5vw">
              <div class="price-container">
                <div class="price-left">平</div>
                <el-input
                  placeholder="请输入平电价"
                  v-model="form.epFlatPrice"
                  style="position: absolute; left: 2vw; width: 18vw"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
        <div class="form-item">
          <el-form-item label="上网电价：">
            <el-input
              v-model="form.epPrice"
              type="number"
              style="width: 20vw"
              placeholder="请输入上网电价"
            ></el-input>
          </el-form-item>
          <div class="tip" style="width: 3.9vw"></div>
          <el-form-item prop="epValleyPrice">
            <div class="price-container" style="margin-left: 7.5vw">
              <div class="price-container">
                <div class="price-left">谷</div>
                <el-input
                  placeholder="请输入谷电价"
                  v-model="form.epValleyPrice"
                  style="position: absolute; left: 2vw; width: 18vw"
                ></el-input>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div
        class="submit-btn"
        @click="addNew('form')"
        v-if="$route.query.id == undefined"
      >
        添加
      </div>
      <div
        class="submit-btn"
        @click="modify('form')"
        v-if="$route.query.id != undefined"
      >
        修改
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCompanyList,
  getStationList,
  addElePrice,
  getPriceDetail,
  modifyElePrice,
} from "@/api/equipment";
export default {
  name: "addPrice",
  data() {
    return {
      form: {
        etId: "", // 企业名称
        psId: "", // 电站名称
        epTipPrice: "", // 尖
        epPeakPrice: "", // 峰
        epFlatPrice: "", // 平
        epValleyPrice: "", // 谷
        epDiscount: "", // 电价折扣
        epPrice: "1", //上网电价
      },
      companyList: [], // 企业列表
      disabled: true, // 电站名称禁用
      stationList: [], // 电站列表
      rules: {
        etId: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        psId: [
          { required: true, message: "电站名称不能为空", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 获取企业列表
    getCompany() {
      getCompanyList().then((res) => {
        this.companyList = res.data;
      });
    },
    // 选择企业名称时触发
    changeCompany(e) {
      this.disabled = false;
      console.log(e);
      let id = e;
      getStationList(id).then((res) => {
        this.stationList = res.data;
      });
    },
    // 新增
    addNew(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          addElePrice(this.form).then((res) => {
            if (res.code == 200) {
              this.$message({
                showClose: false,
                message: "添加成功",
                type: "success",
              });
              this.$router.push("/priceSetting");
            }
          });
        } else {
          return false;
        }
      });
    },
    getDetail() {
      getPriceDetail(this.$route.query.id).then((res) => {
        this.form = res.data;
        this.form.etId = this.form.etId * 1;
        this.form.psId = this.form.psId * 1;
        if (this.form.etId != "") {
          getStationList(this.form.etId).then((res) => {
            console.log(res, "圣安东尼奥就");
            this.stationList = res.data;
          });
        }
      });
    },
    // 修改
    modify(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          modifyElePrice(this.form).then((res) => {
            if (res.code == 200) {
              this.$message({
                showClose: false,
                message: "修改成功",
                type: "success",
              });
              this.$router.push("/priceSetting");
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.getCompany();
    if (this.$route.query.id != undefined) {
      this.disabled = false;
      this.getDetail();
    }
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 2vh;
  box-sizing: border-box;
  .left-part {
    margin-right: 3vw;
    .equipment-title {
      background: url(@/assets/images/titleBg.png);
      background-size: 100% 100%;
      width: 11.1vw;
      height: 5.5vh;
      color: #fff;
      font-size: calc(100vw * 20 / 1920);
      text-align: center;
      line-height: 5.5vh;
      margin-bottom: 1.8vh;
    }
  }
  .form-item {
    display: flex;
    height: 4.6vh;
    margin-bottom: 3vh;
    .tip {
      width: 3.8vw;
      line-height: 4.6vh;
      margin-left: 0.5vw;
      color: #fff;
      font-size: calc(100vw * 15 / 1920);
      margin-right: 4.6vw;
    }
  }
  .submit-btn {
    width: 7.2vw;
    height: 4.6vh;
    background: url(@/assets/images/updown.png);
    background-size: 100% 100%;
    color: #02b5ff;
    font-size: calc(100vw * 18 / 1920);
    text-align: center;
    line-height: 4.6vh;
    margin: 26.1vh 0 0 56.1vw;
    cursor: pointer;
  }
}
.el-form-item::v-deep {
  display: flex;
  height: 4.6vh;
  align-items: center;
  .el-form-item__label {
    width: 7.5vw;
    text-align: left;
    color: #fff;
    font-size: calc(100vw * 16 / 1920);
  }
}
::v-deep .el-input__inner {
  height: 4.6vh;
  background: #0f2455;
  border: 1px solid #286ae8;
  color: #fff;
  font-size: calc(100vw * 16 / 1920);
  outline: none;
  &::placeholder {
    color: #fff;
  }
}
::v-deep .el-select .el-input.is-disabled .el-input__inner {
  background: #0f2455;
  border: 1px solid #286ae8;
  &::placeholder {
    color: #fff;
  }
}
.price-container::v-deep {
  width: 20.1vw;
  height: 4.6vh;
  position: relative;
  display: flex;
  align-items: center;
  background: #0f2455;
  border: 1px solid #286ae8;
  border-radius: 6px;
  .price-left {
    position: absolute;
    left: 0;
    color: #fff;
    font-size: calc(100vw * 16 / 1920);
    width: 2vw;
    line-height: 4.6vh;
    height: 100%;
    text-align: center;
    border-right: 1px solid #286ae8;
    z-index: 999;
  }
  .el-input__inner {
    border: 0;
  }
}
::v-deep .distpicker-address-wrapper select {
  width: 10.3vw;
  background: #0f2455;
  border: 1px solid #286ae8;
  color: #fff;
  margin-right: 1vw;
  height: 4.6vh;
  font-size: calc(100vw * 16 / 1920) !important;
}
</style>
